import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-alijes-index',
  templateUrl: './alijes-index.component.html',
  styleUrls: ['./alijes-index.component.scss']
})
export class AlijesIndexComponent {

  TipoUsuario = TipoUsuario;

  constructor(private authService: AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
